import type { ReactNode } from 'react';

/**
 * A number, ID, code or timestamp: mono, tabular, isolated left-to-right inside RTL text.
 * With `unit`, number and unit stay together (one isolate, no line break between them, UX audit #16);
 * the unit stays outside the left-to-right part so an Arabic unit reads in the UI's own direction.
 */
export function Num({ children, unit }: { children: ReactNode; unit?: string }) {
  const value = (
    <bdi dir="ltr" className="fs-num">
      {children}
    </bdi>
  );
  if (unit === undefined) return value;
  return (
    <span className="fs-num-unit">
      {value}
      {' '}
      {unit}
    </span>
  );
}
